// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-expansion-panel-header[data-v-5e191fa7]{padding:0 10px!important}.v-expansion-panel-content[data-v-5e191fa7] .v-expansion-panel-content__wrap{padding:0!important;min-height:38px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
